import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { CustomerTable } from '@app/components/apps/Customers/CustomerTable';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';

interface CustomersPageProps {
  verified?: boolean | null;
}

const CustomersPage: React.FC<CustomersPageProps> = ({ verified = null }) => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    const breadcrumbPath =
      verified === true ? '/verified-customers' : verified === false ? '/new-customers' : '/customers';

    const breadcrumbName =
      verified === true ? 'Verified Customers' : verified === false ? 'New Customers' : 'Customers';

    setBreadcrumb(
      <BaseBreadcrumbWithRender
        routes={[
          {
            path: breadcrumbPath,
            breadcrumbName,
          },
        ]}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [verified, setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <CustomerTable verified={verified} />
      </Col>
    </Row>
  );
};

export default CustomersPage;
